import React, { useState, useEffect } from 'react';
import './FranchiseeProfile.css';
import { useSelector, useDispatch } from 'react-redux';
import { setSelectedFranchise } from '../redux/actions/franchiseActions'; 
import { useNavigate } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { ProfileCard } from 'tutorapp-components';
import { ToastContainer } from 'react-toastify';

const FranchiseeProfile = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  //userdata obtained after login sucess
  const userData = useSelector((state) => state.auth.userData?.franchise_list);
  const selectedFranchise = useSelector((state) => state.franchise.selectedFranchise);

  const [selectedProfileId, setSelectedProfileId] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (userData && userData.length > 0) {
      setLoading(true);

      // If there's a previously selected franchise, set it as selected
      if (selectedFranchise) {
        setSelectedProfileId(selectedFranchise.franchise_id);
      }
    }
    setLoading(false)
  }, [userData, selectedFranchise]);

  //on selecting franchise
  const onselect = (profile) => {
    setSelectedProfileId(profile.franchise_id);
    dispatch(setSelectedFranchise(profile));
    setErrorMessage('');
  };

  const handleLoginClick = () => {
    if (!selectedFranchise) {
      setErrorMessage('Please select a profile');
    } else {
      navigate('/MyAppointment');
    }
  };

  const profileImagePaths = {
    selected: './images/Selected.svg',
    subject: './images/Subject.svg',
    email: './images/ic_email.svg',
    phone: './images/Phone.svg',
  };

  if (loading) {
    return (
      <div className="loader-container">
        <CircularProgress style={{ color: 'black' }} />
      </div>
    );
  }

  return (
    <div className="container">
      <div className="header-container">
        <img src="/images/User.svg" alt="User Icon" className="header-icon" />
        <div className="header-text" style={{fontFamily: 'GT-Walsheim'   }}>FRANCHISEE PROFILES:</div>
      </div>

      <div className="scrollable-container">
        {userData &&
          userData.map((profile) => (
            <ProfileCard
              key={profile.franchise_id}
              profile={profile}
              isSelected={profile.franchise_id === selectedProfileId}
              onselect={onselect}
              profileImagePaths={profileImagePaths}
            />
          ))}
      </div>

      <button className="login-button" onClick={handleLoginClick}>
        <span className="login-button-text" style={{fontFamily: 'GT-Walsheim'}}>Login</span>
      </button>

      {errorMessage && <div className="error-message" style={{fontFamily: 'GT-Walsheim'}}>{errorMessage}</div>}
       <ToastContainer testID= "franchise-profile" /> 
    </div>
  );
};

export default FranchiseeProfile;
